<template>
  <div class="top">
    <div class="menu">
      <!-- <router-link to="/battle" class="button" id="button"><img src="../assets/img/battle_button.png"></router-link> -->
    </div>
    <img class="bg-icon" src="../assets/img/bg_notitle.png">
    <img class="logo" src="../assets/img/asahi_logo-en.png">
    <div class="talk-avator item1">
      <router-link to="/battle"><div class="balloon">政治</div></router-link>
      <img class="avatar" src="../assets/img/avatars/c2-waving.gif">
    </div>
    <div class="talk-avator item2">
      <div class="balloon">外交</div>
      <img class="avatar" src="../assets/img/avatars/c5-tallking.gif">
    </div>
    <div class="talk-avator item3">
      <div class="balloon">経済</div>
      <img class="avatar" src="../assets/img/avatars/c8-tallking.gif">
    </div>
    <div class="talk-avator item4">
      <div class="balloon">社会保障</div>
      <img class="avatar" src="../assets/img/avatars/c1-disappointed.gif">
    </div>
  </div>
</template>

<script>
export default {
  name: 'top',
  data: () => {
    return {
      message: {
        body: "",
        girl: ""
      }
      // hoge: 'fuga'
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  position: relative;
  height: 100vh;

  // background: url("../assets/img/bg_notitle_opac.png");
  // background-repeat: no-repeat;
  // background-size: contain;
  // background-position: center center;

  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;
}


.menu {
  color: #ed1522;
  font-size: 32px;
  text-align: center;
}
.menu-item {
  margin: 16px 0;
}

.bg-icon {
  position: fixed;
  top: 30vh;
  width: 120%;
  max-width: 464px;
  opacity: 0.1;
  z-index: -1;
}

.logo {
  position: absolute;
  left: 20%;
  bottom: 8px;
  width: 60%;
  max-width: 240px;
}

@keyframes splash {
  100% {
    opacity: 1;
  }
}

.button{
  img {
    width: 60%;
  }
}


.avatar {
  width: 200px;
}

.item1 {
  position: absolute;
  right: 10%;
  bottom: 15%;
  text-align: center;
}
.item2 {
  position: absolute;
  left: 5%;
  bottom: 5%;
}
.item3 {
  position: absolute;
  right: 0;
  top: 16%;
}
.item4 {
  position: absolute;
  left: 0;
  top: 12%;
}

.balloon {
  text-align: center;
  font-size: 24px;
  padding: 4px;
  // border: 3px solid #ed1522;
  background-clip: #fff;
  color: #ed1522;
  font-weight: 800;
  text-decoration: none;
  line-height: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/top.vue